import React, { useState, useEffect } from 'react';
import { Badge, Calendar } from 'antd';
import { withRouter } from '../../utils/tms-with-router/tms-with-router';
import TmsNakshatramCalendarDrawer from './tms-nakshatram-calendar-drawer';
import { useGetNakshatramCalendar } from '../../services/nakshatram/calendar/nakshatram-calendar.service.hook';
import dayjs from 'dayjs';

const TmsNakshatramCalendar = () => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const [fromDate, setFromDate] = useState(
    dayjs().subtract(15, 'days').format('YYYY-MM-DD')
  );
  const [toDate, setToDate] = useState(
    dayjs().add(1, 'month').add(15, 'day').format('YYYY-MM-DD')
  );

  const { data: calendarData } = useGetNakshatramCalendar(fromDate, toDate);

  const [dateAggregatedData, setDateAggregatedData] = useState({});

  useEffect(() => {
    if (calendarData) {
      const aggregatedData = {};
      calendarData.items.forEach((entry) => {
        if (!aggregatedData[entry.date]) {
          aggregatedData[entry.date] = [];
        }
        aggregatedData[entry.date].push(entry);
      });
      setDateAggregatedData(aggregatedData);
    }
  }, [calendarData]);

  const onDateSelect = (date) => {
    const selectedDate = date.format('YYYY-MM-DD');
    setSelectedDate(selectedDate);
    setDrawerVisible(true);
    console.log('selectedDate', selectedDate);
  };

  const dateCellRender = (current) => {
    const date = current.format('YYYY-MM-DD');
    const nakshatramsForDate = dateAggregatedData[date];
    return (
      <div>
        {nakshatramsForDate?.map((nakshatramDate) => (
          <Badge
            key={nakshatramDate.id}
            text={nakshatramDate.nakshatram?.name}
            status='success'
          />
        ))}
      </div>
    );
  };

  const onPanelChange = (date) => {
    const fromDate = date.subtract(5, 'day').format('YYYY-MM-DD');
    const toDate = date.add(1, 'month').add(5, 'day').format('YYYY-MM-DD');

    setFromDate(fromDate);
    setToDate(toDate);
  };

  const cellRender = (current, info) => {
    if (info.type !== 'date') {
      return info.originNode;
    }
    return dateCellRender(current);
  };

  return (
    <>
      <Calendar
        onSelect={onDateSelect}
        cellRender={cellRender}
        onPanelChange={(date) => {
          onPanelChange(date);
        }}
      />
      <TmsNakshatramCalendarDrawer
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        selectedDate={selectedDate}
        currentDateData={dateAggregatedData[selectedDate]}
      />
    </>
  );
};

export default withRouter(TmsNakshatramCalendar);
